import { CTW_API_ENDPOINT } from '../utils';
import coreAPIService from './coreAPIService';

export interface PlatformConfig {
    id?: number;
    platformBudgetPercent?: number;
    marginValue?: number;
    dataCostPercent?: number;
    dataCostValue?: number;
    marketingCost?: number;
    authenticationCost?: number;
    utilityCost?: number;
    updatedAt?: string;
    orgId: string;
}

export interface PlatformBudgetConfigRequest {
    orgId: string;
    marginValue: number;
    dataCostValue: number;
    marketingCost: number;
    authenticationCost: number;
    utilityCost: number;
    remarks: string;
}

const isSuccessResponse = (response: any) =>
    response?.meta?.status === true ||
    response?.meta?.status === 200 ||
    response?.meta?.code === 200;

class PlatformBudgetService {
    /**
     * Fetch all platform configurations
     */
    async fetchPlatformConfigs() {
        try {
            const response: { meta: any, data: any } = await coreAPIService.get(CTW_API_ENDPOINT, '/v2/admin/fetch-platform-conf');
            // Assuming data contains the array directly or in a `data` field
            if (isSuccessResponse(response)) return response.data?.data || response.data || [];
            throw new Error(response.meta?.message || 'Failed to fetch platform configs');
        } catch (error: any) {
            throw new Error(error.response?.data?.meta?.message || error.message || 'Failed to fetch platform configs');
        }
    }

    /**
     * Add/update platform budget configuration for an organization
     */
    async updatePlatformBudgetConfig(orgId: string, payload: PlatformBudgetConfigRequest): Promise<any> {
        try {
            const response: any = await coreAPIService.post(
                CTW_API_ENDPOINT,
                `/v2/admin/update-platform-budget-config?orgId=${encodeURIComponent(orgId)}`,
                payload
            );
            if (isSuccessResponse(response)) return response.data;
            throw new Error(response.meta?.message || 'Failed to save platform budget config');
        } catch (error: any) {
            throw new Error(error.response?.data?.meta?.message || error.message || 'Failed to save platform budget config');
        }
    }

    async deletePlatformConfig(orgId: string): Promise<any> {
        try {
            const response: any = await coreAPIService.delete(CTW_API_ENDPOINT, `/v2/admin/delete-config?orgId=${encodeURIComponent(orgId)}`);
            if (isSuccessResponse(response)) return response.data;
            throw new Error(response.meta?.message || 'Failed to delete platform config');
        } catch (error: any) {
            throw new Error(error.response?.data?.meta?.message || error.message || 'Failed to delete platform config');
        }
    }
}

export default new PlatformBudgetService();
